module.exports = __webpack_public_path__ + "img/128.fe227973.jpg";